import get from "lodash/get";
import set from "lodash/set";
import round from "lodash/round";
import convert from "convert-units";

function updateUnits(obj, preferred) {
  if (!("_units" in obj) || get(obj, "modal.type", false) === "add-exercise")
    return;
  const conversions = obj._units;
  delete obj._units;

  // Go over units and give them the measurement system based off of user preferred unit.
  Object.keys(conversions).forEach((key) => {
    const conversion = conversions[key];
    if (!conversion || !conversion.type) return;

    const { type, imperial, metric } = conversion;
    const from = type === "metric" ? metric : imperial;
    const to = type === "metric" ? imperial : metric;
    const value = get(obj, key);

    // If we switched from the preferred measurement system then we update the inputs.
    if (process.browser) {
      // Find input and update its value.
      const input = document.querySelector(`[data-name="${key}"]`);

      if (input) {
        if (type !== preferred) {
          // Find toggle and switch to back to preferred option.
          const toggle = document.querySelector(
            `[name="_units[${key}][type]"][value="${preferred}"]`
          );
          if (toggle) toggle.click();
          // Find input and convert to prefered units.
          input.value = convertUnit(value, from, to);
        }

        // Ensure properly rounded inputs.
        input.value = round(input.value, 2);
      }
    }

    // Update all data in obj to metric for api submission.
    if (from !== metric) set(obj, key, convertUnit(value, from, metric));
  });

  return obj;
}

export function convertUnit(value, from, to) {
  if (value == null || value === "") return "";
  if (from === to) return value;
  return convert(value).from(from).to(to);
}
export const getBodywweightAndUnit = (bodyweight, userPreference) => {
  if (!bodyweight) return "-";
  if (userPreference === "imperial")
    return `${round(convertUnit(bodyweight, "kg", "lb"), 1)} Lb`;
  return `${round(bodyweight, 1)} Kg`;
};
export default updateUnits;
